import { useApi, useToaster } from "@shopexperts/shared";
import { useMutation, useQueryClient } from "@tanstack/vue-query";
import type { UpdatePageCollectionRequest } from "@shopexperts/shared";

interface UpdatePageCollectionParams {
  id: number;
  data: UpdatePageCollectionRequest;
}

export function useUpdatePageCollection() {
  const api = useApi();
  const queryClient = useQueryClient();
  const toaster = useToaster();

  return useMutation({
    mutationFn: ({ id, data }: UpdatePageCollectionParams) =>
      api.admin.pages.updateCollection({ params: { id }, body: data }),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ["admin", "page-collections"] });
      queryClient.invalidateQueries({ queryKey: ["admin", "page-collections", variables.id] });
      toaster.create({
        title: "Collection updated successfully",
        type: "success",
      });
    },
    onError: (error: any) => {
      const errorMessage =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        error?.message ||
        "An error occurred while updating the collection.";

      toaster.create({
        title: "Failed to update collection",
        description: errorMessage,
        type: "error",
      });
    },
  });
}
